import { COLORS } from '@constants';
import styled from 'styled-components';

export const StyledPanel = styled.div`
    background: ${COLORS.$gray10Black};
    border-radius: 8px;
    padding: 24px;
`;

export const StyledSteps = styled.ol`
    color: ${COLORS.$gray60Black};
    margin: 0 0 24px;
    padding-left: 20px;

    li {
        line-height: 24px;
    }

    li + li {
        margin-top: 12px;
    }

    strong {
        font-weight: 600;
    }
`;

export const StyledCopyButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 0;
    border: 0;
    background: none;
    cursor: pointer;
    font-family: inherit;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: ${COLORS.$gray60Black};
`;
